export const downloadFile = (name: string, href: string): void => {
    const link = document.createElement("a");
    link.href = href;
    link.download = name;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
